export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!../../../../node_modules/vue-svg-inline-loader/dist/index.min.js??ref--2-1!./MediaBlock.vue?vue&type=template&id=8b105ab2&"


//////////////////
// WEBPACK FOOTER
// ./scripts/components/MediaBlock.vue?vue&type=template&id=8b105ab2&
// module id = 442
// module chunks = 0